import type {ReactElement, Ref} from 'react';
import React, {forwardRef} from 'react';
import {useAppDispatch} from '@/hooks';
import {updateTimelineHoverPosition} from '../../timeline-reducer';
import styles from './resize-handle.module.scss';

export type ResizeHandleSide = 'left' | 'right';

interface ResizeHandleProps {
  side: ResizeHandleSide;
  onPointerDown: (e: React.PointerEvent) => void;
  isVisible?: boolean;
  isItemSelected?: boolean;
}

export const ResizeHandle = forwardRef(function ResizeHandle({side, onPointerDown, isVisible = true, isItemSelected = false}: ResizeHandleProps, ref: Ref<HTMLDivElement>): ReactElement {
  const dispatch = useAppDispatch();

  const handlePointerDown = (e: React.PointerEvent): void => {
    e.preventDefault();
    e.stopPropagation();
    onPointerDown(e);
  };

  const handleMouseEnter = (): void => {
    dispatch(updateTimelineHoverPosition(undefined));
  };

  return (
    <div
      ref={ref}
      className={`${styles.handle} ${styles[side]} ${isVisible ? styles.visible : ''} ${isItemSelected ? styles.inset : ''}`}
      onPointerDown={handlePointerDown}
      onMouseEnter={handleMouseEnter}
      role="slider"
      aria-label={`Resize ${side} handle`}
      tabIndex={-1}
    >
      <div className={styles.handleBar} />
    </div>
  );
});
